module.exports = __webpack_public_path__ + "static/img/earning-tip.2df3348.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toutiao/earning-tip.png
// module id = DYhr
// module chunks = 156